import { useState } from 'react';
import { takeOverSave } from '@/app/tabLock';
import { useI18n } from '@/ui/i18n/I18nProvider';
import styles from './ErrorScreen.module.css';

/**
 * "Little Cozy Town đang mở ở tab khác" (content-schemas §11.2): shown by a second tab at boot, and by a tab
 * whose game was taken over. "Chơi ở tab này" asks the other tab to save and let go, then reloads here.
 */
export function OtherTabScreen() {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  return (
    <div className={styles.screen} role="alert" data-testid="other-tab">
      <div className={styles.card}>
        <h1 className={styles.title}>{t('system.other_tab.title')}</h1>
        <p>{t('system.other_tab.body')}</p>
        <button
          type="button"
          className={styles.button}
          disabled={busy}
          onClick={() => {
            setBusy(true);
            void takeOverSave().finally(() => {
              window.location.reload();
            });
          }}
        >
          {t('system.other_tab.take_over')}
        </button>
      </div>
    </div>
  );
}
